"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Resource = exports.APIAction = exports.Action = exports.ERROR_SUFFIX = exports.SUCCESS_SUFFIX = void 0;

var _lodash = require("lodash");

var _URITemplate = _interopRequireDefault(require("urijs/src/URITemplate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SUCCESS_SUFFIX = '_SUCCESS';
exports.SUCCESS_SUFFIX = SUCCESS_SUFFIX;
var ERROR_SUFFIX = '_FAIL';
exports.ERROR_SUFFIX = ERROR_SUFFIX;

var Action = function Action(name) {
  _classCallCheck(this, Action);

  this.main = name;
};

exports.Action = Action;

var APIAction = /*#__PURE__*/function (_Action) {
  _inherits(APIAction, _Action);

  var _super = _createSuper(APIAction);

  function APIAction(name) {
    var _this;

    _classCallCheck(this, APIAction);

    _this = _super.call(this, name);
    _this.success = name + SUCCESS_SUFFIX;
    _this.fail = name + ERROR_SUFFIX;
    return _this;
  }

  return APIAction;
}(Action);

exports.APIAction = APIAction;

var Resource = /*#__PURE__*/function () {
  function Resource(name) {
    var endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/{resource}/{id}/';

    _classCallCheck(this, Resource);

    this.name = name;
    this.endpoint = (0, _URITemplate["default"])(endpoint);
    this.actions = {
      list: new APIAction("LIST_".concat((0, _lodash.toUpper)(this.name))),
      search: new APIAction("SEARCH_".concat((0, _lodash.toUpper)(this.name))),
      create: new APIAction("CREATE_".concat((0, _lodash.toUpper)(this.name))),
      retrieve: new APIAction("RETRIEVE_".concat((0, _lodash.toUpper)(this.name))),
      update: new APIAction("UPDATE_".concat((0, _lodash.toUpper)(this.name))),
      destroy: new APIAction("DESTROY_".concat((0, _lodash.toUpper)(this.name)))
    };
  }

  _createClass(Resource, [{
    key: "list",
    value: function list() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var overwriteData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var includeEntityID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var url = this.endpoint.expand({
        resource: (0, _lodash.kebabCase)(this.name)
      });
      return {
        type: this.actions.list.main,
        payload: {
          request: {
            url: this._cleanURL(url),
            method: 'GET',
            params: params,
            includeEntityID: includeEntityID,
            overwriteData: overwriteData
          }
        }
      };
    }
    /**
     * This method is like "list" except will make multiple requests
     * in order to follow API pagination.
    */

  }, {
    key: "listAll",
    value: function listAll() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = this.endpoint.expand({
        resource: (0, _lodash.kebabCase)(this.name)
      });
      return {
        type: this.actions.list.main,
        payload: {
          request: {
            url: this._cleanURL(url),
            method: 'GET',
            params: params,
            followPagination: true
          }
        }
      };
    }
    /**
     * This method is like "list" except it requires a "search" param.
     * We use this method to save the select's data in another place
     * so we don't overwrite the data displayed in the app.
     */

  }, {
    key: "search",
    value: function search(_search) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var includeEntityID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var url = this.endpoint.expand({
        resource: (0, _lodash.kebabCase)(this.name)
      });
      return {
        type: this.actions.search.main,
        payload: {
          request: {
            url: this._cleanURL(url),
            method: 'GET',
            params: _objectSpread(_objectSpread({}, params), {}, {
              search: _search
            }),
            includeEntityID: includeEntityID
          }
        }
      };
    }
  }, {
    key: "retrieve",
    value: function retrieve(id) {
      var url = this.endpoint.expand({
        resource: (0, _lodash.kebabCase)(this.name),
        id: id
      });
      return {
        type: this.actions.retrieve.main,
        payload: {
          request: {
            url: this._cleanURL(url),
            method: 'GET'
          }
        }
      };
    }
  }, {
    key: "create",
    value: function create(data) {
      var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var url = this.endpoint.expand({
        resource: (0, _lodash.kebabCase)(this.name)
      });
      return {
        type: this.actions.create.main,
        payload: {
          request: {
            url: this._cleanURL(url),
            method: 'POST',
            data: data,
            headers: headers
          }
        },
        meta: {
          object: data
        }
      };
    }
  }, {
    key: "update",
    value: function update(data) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var url = this.endpoint.expand({
        resource: (0, _lodash.kebabCase)(this.name),
        id: id ? id : data.id
      });
      return {
        type: this.actions.update.main,
        payload: {
          request: {
            url: this._cleanURL(url),
            method: 'PATCH',
            data: data,
            headers: headers
          }
        },
        meta: {
          object: data
        }
      };
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var url = this.endpoint.expand({
        resource: (0, _lodash.kebabCase)(this.name),
        id: id ? id : data.id
      });
      return {
        type: this.actions.destroy.main,
        payload: {
          request: {
            url: this._cleanURL(url),
            method: 'DELETE'
          }
        },
        meta: {
          object: data
        }
      };
    }
  }, {
    key: "_cleanURL",
    value: function _cleanURL(url) {
      return url.replace('//', '/');
    }
  }]);

  return Resource;
}();

exports.Resource = Resource;